module.exports = __webpack_public_path__ + "img/timeline-face-7.0c65330f.png";